import { sendHTTPRequest } from "@/util/http.ts"
import { goalbookUrls } from "@/util/links.js"
import { Resource } from "@/resources/resource_types.ts"

export async function getResources(
  resourceUuids: string[],
  queryParams: Record<string, string> = {}
): Promise<Resource[]> {
  if (!resourceUuids || resourceUuids.length === 0) {
    return []
  }

  const urlParams = {
    ...queryParams,
    uuids: resourceUuids.join(',')
  }

  try {
    const response = await sendHTTPRequest({
      url: `${goalbookUrls.pathwaysApi}/resources`,
      method: 'GET',
      urlParams,
      includeCredentials: true
    })

    return await response.json() as Resource[]
  } catch (e) {
    throw new Error(`Failed to fetch resources for UUIDs: ${resourceUuids.join(', ')}`, { cause: e })
  }
}
